import { render, staticRenderFns } from "./SelectPoint.vue?vue&type=template&id=7d138e83&scoped=true"
import script from "./SelectPoint.vue?vue&type=script&lang=js"
export * from "./SelectPoint.vue?vue&type=script&lang=js"
import style0 from "./SelectPoint.vue?vue&type=style&index=0&id=7d138e83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d138e83",
  null
  
)

export default component.exports